// Uploaded images may be stored as absolute URLs from whichever host saved them
// (e.g. http://localhost:5244/uploads/x.png). Point every /uploads/ link at the API instead.
const UPLOAD_URL_PATTERN = /^(?:https?:\/\/[^/]+)?(\/uploads\/.+)$/i;

export function normalizeUploadUrls(value, apiBaseUrl) {
  if (typeof value === 'string') {
    const match = value.trim().match(UPLOAD_URL_PATTERN);
    return match ? `${apiBaseUrl}${match[1]}` : value;
  }
  if (Array.isArray(value)) {
    return value.map((item) => normalizeUploadUrls(item, apiBaseUrl));
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, normalizeUploadUrls(item, apiBaseUrl)]),
    );
  }
  return value;
}
